import { getHasGlobalFilterDurationChangedFromDefault } from '@modules/dashboard/helpers';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { parseStringifiedDuration } from '@modules/feed/utils/parseStringifiedDuration';
import { useGetQuantifyDuration } from '@modules/quantify/hooks';
import { DashboardAnalysisSubtitleContent } from './DashboardAnalysisSubtitleContent';

export const DashboardQuantifyHeaderSubtitle = () => {
  const quantifyDuration = useGetQuantifyDuration();
  const globalFilterDuration = useDashboardStore(({ query }) => query.duration);

  const hasGlobalFilterDurationChangedFromDefault =
    getHasGlobalFilterDurationChangedFromDefault(globalFilterDuration);

  const duration = hasGlobalFilterDurationChangedFromDefault
    ? quantifyDuration
    : parseStringifiedDuration(quantifyDuration);

  if (!duration) {
    return null;
  }

  return (
    <DashboardAnalysisSubtitleContent
      duration={duration}
      hasGlobalFilterDurationChangedFromDefault={
        hasGlobalFilterDurationChangedFromDefault
      }
    />
  );
};
